import { NavigateFunction } from 'react-router-dom';
export const hasManagedWifi = (partner: { productAvailability?: string[] } | null | undefined): boolean =>
    partner?.productAvailability?.includes('MANAGED_WIFI') ?? false;

export const handleWatchNowClick = async (termsAccepted:boolean, authToken:string, navigate: NavigateFunction) => {
    const logoutUrl = process.env.REACT_APP_LOGOUT_URL as string;
    try {
        if (!termsAccepted) {
            navigate('/terms');
            return;
          }
    const response = await fetch('/api/watchNow',
    {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+authToken
        }
    })
    .then(async response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
            window.location.href = logoutUrl;
        }
        const watchNowResponse = await response.json();
        if (watchNowResponse.expired) {
            // Handle the expiration case
            console.log("The content is expired.");
            window.location.href = logoutUrl;
        } else {
            // Handle the watchNow attribute
            console.log("Watch Now URL:", watchNowResponse.watchNowUrl);
            window.open(watchNowResponse.watchNowUrl, '_blank');
        }
    })
    .catch(error => {
        console.error("Error fetching watchNow data:", error);
        window.location.href = logoutUrl;
    });
      
    } catch (error) {
      console.error("Error fetching watchNow data:", error);
      window.location.href = logoutUrl;
    }
  };